export default __webpack_public_path__ + "static/media/1196.9344322a.png";